/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementLightboxIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementLightboxIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path d="M5.5 14H3.5V13H5.5V14Z" fill="currentColor" />
            <path d="M9 14H7V13H9V14Z" fill="currentColor" />
            <path d="M12.5 14H10.5V13H12.5V14Z" fill="currentColor" />
            <path
              d="M6 3C6.55228 3 7 3.44772 7 4C7 4.55228 6.55228 5 6 5C5.44772 5 5 4.55228 5 4C5 3.44772 5.44772 3 6 3Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 1C12.5523 1 13 1.44771 13 2V10C13 10.5523 12.5523 11 12 11H4C3.44772 11 3 10.5523 3 10V2C3 1.44772 3.44772 1 4 1H12ZM4.70703 10H11.293L8 6.70703L4.70703 10ZM4 9.29297L7.29297 6C7.68348 5.60953 8.31652 5.60953 8.70703 6L12 9.29297V2H4V9.29297Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementLightboxIcon.tags = [
  'lightbox',
  'gallery',
  'image',
  'slideshow',
  'preview',
  'photo',
  'viewer',
];

ElementLightboxIcon.category = 'Navigator';

ElementLightboxIcon.iconSize = 16;
